import config from '@/config'
import { isEmbedded, postMessage } from './embeddable.utils'

const embeddablePlugin = (store) => {
  store.subscribe((mutation) => {
    if (isEmbedded()) {
      if (mutation.type === 'setCurrentUser') {
        postMessage({
          type: 'set-current-user',
          payload: { id: mutation.payload?.id },
        })
        postMessage({
          type: 'set-tracking',
          payload: config.mixpanel,
        })
      }
    }
  })
}

export default embeddablePlugin
